import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_UPDATE_ISSUED_RECEIPT_STATUS_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION =
	graphql(/* GraphQL */ `
		mutation ReservationDetailUpdateIssuedReceiptStatusForManagementReservationItemDetailUpdate(
			$input: ReservationDetailUpdateIssuedReceiptStatusInput!
		) {
			reservationDetailUpdateIssuedReceiptStatus(input: $input) {
				reservationDetail {
					statusReceiptIssued
				}
				userErrors
			}
		}
	`);
